module.exports = __webpack_public_path__ + "static/media/997728.06bea5a9.jpg";